import axios from "axios";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_BASE_URL;

const FLOOR_WIDTH = 1000;
const FLOOR_HEIGHT = 550;

export function useOutletTables(selectedOutlet) {
    const [rawTableWithCoordinates, setRawTableWithCoordinates] = useState([]);
    const [tablesWithCoordinates, setTablesWithCoordinates] = useState([]);
    const [allTableIdsUnion, setAllTableIdsUnion] = useState([]);
    const token = localStorage.getItem("token");
    const outlet_name = selectedOutlet;

    const load = async () => {
        try {
            const coordRes = await axios.post(
                `${baseUrl}/get-table-coordinates`,
                { outlet_name, token }
            );

            const tableRes = await axios.post(
                `${baseUrl}/get-tables-by-outlet`,
                { outlet_name, token }
            );

            const coordTables = coordRes.data.tables || [];
            setRawTableWithCoordinates(coordTables);

            let mappedCoords = [];

            if (coordTables.length > 0) {
                mappedCoords = coordTables.map(t => ({
                    id: t.table_no,
                    x: parseFloat(t.x_coordinate) * FLOOR_WIDTH,
                    y: parseFloat(t.y_coordinate) * FLOOR_HEIGHT,
                }));
            } else {
                const fallbackTables = tableRes.data.tables || [];
                mappedCoords = fallbackTables.map(t => ({
                    id: t.Table_No,
                    x: FLOOR_WIDTH * 0.02,
                    y: FLOOR_HEIGHT * 0.035
                }));
            }

            setTablesWithCoordinates(mappedCoords);

            const outletTables = tableRes.data.tables || [];

            const coordIds = mappedCoords.map(t => t.id);
            const outletIds = outletTables.map(t => t.Table_No);

            const unionIds = Array.from(new Set([...coordIds, ...outletIds]))
                .map(id => ({ id }));

            setAllTableIdsUnion(unionIds);

        } catch (err) {
            console.error(err);
            toast.error(
                err.response?.data?.error ||
                err.response?.data?.message ||
                err.message ||
                "Failed to fetch table data"
            );
            setTablesWithCoordinates([]);
            setAllTableIdsUnion([]);
        }
    };

    useEffect(() => {
        if (!selectedOutlet) return;

        load();
    }, [selectedOutlet, token]);

    return {
        tablesWithCoordinates,
        allTableIdsUnion,
        setTablesWithCoordinates,
        setAllTableIdsUnion,
        rawTableWithCoordinates,
        setRawTableWithCoordinates,
        load
    };
}
